export function Brand() {
  return (
    <img
      style={{
        height: "8.5vh",
        pointerEvents: "none",
      }}
      src="/images/ccia-logo-02.png"
      alt="app-logo"
    />
  );
}
